import React from 'react';
import { Link } from '@amzn/atoz-web/Link';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var ShiftFlowActionsOption = function (_a) {
    var ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className, dataTestId = _a.dataTestId, onClick = _a.onClick;
    return (React.createElement(StyledLink, { className: className, dataTestId: dataTestId, onClick: onClick, "aria-label": ariaLabel }, children));
};
var StyledLink = styledWithTheme(Link)(function (_a) {
    var theme = _a.theme;
    return "\n    cursor: pointer;\n    display: block;\n    margin-bottom: ".concat(theme.selectors.space('S400'), "px;\n    text-decoration: none;\n    \n    &:last-of-type {\n        margin-bottom: 0;\n    }\n");
});
